import Swiper, { Mousewheel, FreeMode } from 'swiper';
import 'swiper/css';

import gsap from 'gsap';
import { CustomEase } from 'gsap/CustomEase';
gsap.registerPlugin(CustomEase);

export default {
	init() {
		console.log('home');

		jQuery(document).ready(function ($) {
			var $body = $('body'),
				isLoaded = false,
				isIntro = $body.hasClass('intro--on'),
				$header = $('.main_header'),
				$main = $('main');

			window.addEventListener('load', function () {
				isLoaded = true;
				initHP();
			});

			setTimeout(function () {
				if (!isLoaded) {
					initHP();
				}
			}, 1000);

			function initHP() {
				if (isIntro) {
					const obj = document.getElementById('loadingPercent');
					animateValue(obj, 0, 99, 2000, endAnimation); //Loading percent

					setTimeout(() => {
						setHpSwiper();
					}, 500);
				} else {
					showElements();
					setHpSwiper();
				}
			}

			function setHpSwiper() {
				const swiper = new Swiper('.hp_swiper', {
					modules: [Mousewheel, FreeMode],
					slidesPerView: 'auto',
					spaceBetween: 2,
					centeredSlides: true,
					centeredSlidesBounds: true,
					initialSlide: 2,
					freeMode: {
						enabled: true,
						sticky: true,
						momentumBounce: false,
					},
					mousewheel: {
						enabled: true,
						sensitivity: 4,
						eventsTarget: '.main',
					},
				});
			}

			function animateValue(obj, start, end, duration, callback) {
				let startTimestamp = null;
				const step = (timestamp) => {
					if (!startTimestamp) startTimestamp = timestamp;
					const progress = Math.min(
						(timestamp - startTimestamp) / duration,
						1
					);
					obj.innerHTML = Math.floor(
						progress * (end - start) + start
					);
					if (progress < 1) {
						window.requestAnimationFrame(step);
					} else {
						callback();
					}
				};
				window.requestAnimationFrame(step);
			}

			function showElements() {
				$body.removeClass('intro--off');
				gsap.to([$header, $main], {
					y: '0',
					delay: 1,
					duration: 1,
					ease: CustomEase.create('custom', '0.47, 0, 0.03, 1'),
				});
			}

			function endAnimation() {
				setTimeout(() => {
					document.body.classList.add('hp--loaded');
				}, 500);
				setTimeout(() => {
					document.body.classList.add('intro--end');
				}, 2500);
			}
		});
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
};
